import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { httpReauest } from "../../utils/httpRequest";
import { toast } from "react-toastify";
import { socket } from "../../helpers/socketHelper";
import { FaAlignRight, FaAngleRight, FaUser } from "react-icons/fa";
import Loading from "../common/Loading";
import { Link, useSearchParams } from "react-router-dom";

const ChatMobile = () => {
  const [endwork, setendwork] = useState();
  const [content, setcontent] = useState();
  const [dealerData, setdealerData] = useState();
  const [messages, setmessages] = useState([]);
  const [loading, setloading] = useState([]);
  const [ip, setip] = useState();
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    getData();
    if (searchParams.get("text") && searchParams.get("ip")) {
      handleSubmitQuery(searchParams.get("text"), searchParams.get("ip"));
    }
    const now = new Date();
    if (now.getHours() >= 17) {
      setendwork(true);
    }
  }, []);

  useEffect(() => {
    if (!socket.connected) {
      socket.connect();
    }
    const handleReceiveMessage = (senderId, content) => {
      const newMessage = {
        sender: "admin",
        content,
      };
      setmessages((c) => [...c, newMessage]);
      scrollToBottom();
    };

    socket.on("receive-message", handleReceiveMessage);

    return () => {
      socket.off("receive-message", handleReceiveMessage);
    };
  }, [socket]);

  async function getData(params) {
    setloading(true);

    await axios
      .get("https://api.ipify.org/?format=json")
      .then(async ({ data }) => {
        setip(data?.ip);

        await httpReauest("GET", "/message/" + data?.ip, {}, {})
          .then(({ data: data2 }) => {
            setmessages(data2);
          })
          .catch((err) => {
            console.log(err);
          });
      });

    await httpReauest("GET", `/data`, {}, {}).then(({ data }) => {
      setdealerData(data?.data[0]);
    });
    setloading(false);
  }

  const messageRef = useRef();

  useEffect(() => {
    if (messages) {
      scrollToBottom();
    }
  }, [messages]);

  const scrollToBottom = () => {
    messageRef.current?.scrollTo({ top: 9999999 });
  };

  async function handleSubmit(e) {
    e.preventDefault();
    await httpReauest(
      "POST",
      "/message",
      { userId: ip, content, reciver: "admin" },
      {}
    )
      .then(({ status }) => {
        if (status === 201) {
          setmessages((c) => [...c, { content, sender: ip, reciver: "admin" }]);
          if (messages.length === 0) {
            setTimeout(() => {
              const newMessage = {
                sender: "admin",
                content: dealerData.welcomeText,
              };
              setmessages((c) => [...c, newMessage]);
              scrollToBottom();
            }, 3000);
          }
          setcontent("");
        }
      })
      .catch((err) => {
        toast.error(err.response?.data?.message);
      });

    await socket.emit("send-message", "admin", content);
  }

  async function handleSubmitQuery(e, ipp) {
    await httpReauest(
      "POST",
      "/message",
      { userId: ipp, content: e, reciver: "admin" },
      {}
    )
      .then(({ status }) => {
        if (status === 201) {
          setmessages((c) => [
            ...c,
            { content: e, sender: ipp, reciver: "admin" },
          ]);
          if (messages.length === 0) {
            setTimeout(() => {
              const newMessage = {
                sender: "admin",
                content: dealerData.welcomeText,
              };
              setmessages((c) => [...c, newMessage]);
              scrollToBottom();
            }, 3000);
          }
          setcontent("");
        }
      })
      .catch((err) => {
        toast.error(err.response?.data?.message);
      });
  }

  return (
    <div
      dir="rtl"
      className="w-full h-full  p-0  bg-white z-50 flex items-center"
    >
      <div
        ref={messageRef}
        className="flex flex-col gap-3 h-[70vh] overflow-y-scroll w-full"
      >
        {loading ? (
          <div className="absolute left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%]">
            <Loading />
          </div>
        ) : messages.length != 0 ? (
          messages?.map((e) => {
            if (e.reciver == "admin") {
              return (
                <span>
                  <div className="w-fit p-3 bg-black border-brand text-white rounded-[10px] max-w-[80%] me-auto text-right text-[14px]">
                    {e.content}
                  </div>
                  {e?.createdAt ? (
                    <div className="text-[12px] ml-auto mt-1 w-fit pr-1">
                      {" "}
                      {new Date(e?.createdAt).toLocaleTimeString(
                        navigator.language,
                        {
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: false,
                        }
                      )}
                      {" | "}
                      {e?.createdAt &&
                        new Intl.DateTimeFormat("fa-IR").format(
                          new Date(e?.createdAt)
                        )}
                    </div>
                  ) : (
                    <div className="text-[12px] ml-auto mt-1 w-fit pr-1">
                      لحظاتی پیش
                    </div>
                  )}
                </span>
              );
            } else {
              return (
                <span className="">
                  <div className="w-fit flex gap-2  bg-white  items-end  max-w-[80%] ms-auto text-right text-[14px]">
                    <span className="p-3 border rounded-t-[10px] rounded-r-[10px] border-gray-300">
                      {e.content}
                    </span>
                    <span className="w-fit p-1 rounded-full border border-gray-300 ">
                      <FaUser />
                    </span>
                  </div>
                  {e?.createdAt ? (
                    <div className="text-[12px] mr-auto mt-1 w-fit pl-1">
                      {" "}
                      {new Date(e?.createdAt).toLocaleTimeString(
                        navigator.language,
                        {
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: false,
                        }
                      )}
                      {" | "}
                      {e?.createdAt &&
                        new Intl.DateTimeFormat("fa-IR").format(
                          new Date(e?.createdAt)
                        )}
                    </div>
                  ) : (
                    <div className="text-[12px] mr-auto mt-1 w-fit pl-1">
                      لحظاتی پیش
                    </div>
                  )}
                </span>
              );
            }
          })
        ) : (
          <div className="absolute left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] text-center font-bold flex flex-col items-center justify-center">
            <p className="mb-3">برای شروع مکالمه چیزی بنویسید</p>{" "}
            {endwork && (
              <p className="mb-3">
                کارمند های شرکت تا ساعت 17:00 پاسخگو هستند برای چت آنلاین
                میتوانید فردا ارتباط بگیرید
              </p>
            )}
            <Link
              style={{ width: "fit-content", fontSize: "14px" }}
              className="btn-brand"
              to={"/faq"}
            >
              سوالات متداول
            </Link>
          </div>
        )}
      </div>

      <div
        className="absolute flex justify-center items-center left-0 top-0 w-full rounded-[10px] bg-white p-4 z-50"
        onSubmit={handleSubmit}
      >
        <span className="flex flex-col items-center justify-center">
          <img src="/logo_1924.svg" alt="لوگوی 1924" className="w-[80px]" />
          <h1 className="text-[8px] font-medium">
            مرکز خرید و فروش ماشین های سنگین
          </h1>
        </span>
        <Link to={"/"}>
          <img
            src="/Arrow - Left 2.png"
            alt="filter"
            className="absolute translate-y-[-50%] top-[50%] right-4 cursor-pointer"
          />
        </Link>
      </div>

      <form
        className="absolute flex justify-center items-center bottom-2 left-2 w-[96%] "
        onSubmit={handleSubmit}
      >
        <input
          className="w-full form-brand xl:min-w-[210px] h-[58px]"
          placeholder="پیام خود را بنویسید ..."
          onChange={(e) => setcontent(e.target.value)}
          value={content}
        />
        <button type="submit">
          <img
            src="/1/Send.png"
            alt="filter"
            className="absolute translate-y-[-50%] top-[50%] left-4"
          />
        </button>
      </form>
    </div>
  );
};

export default ChatMobile;
